<template>
    <div class="CoverageFormat">
      <img
        src="/images/QOxVANy.jpg"
        alt="Internet connectivity in Bulgaria"
        class="banner-img CoverageFormat__saturation"
      />
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION</strong> - The current population of Bulgaria in 2022 is 6,844,597*</li>
            <li><strong>NEIGHBOURING COUNTRIES</strong> - Romania, Serbia, Macedonia, Greece, and Turkey.</li>
            <li><strong>LANGUAGE SPOKEN</strong> - <strong>Bulgarian</strong>. 85% speak Bulgarian, 2.5% Macedonian.</li>
            <li><strong>CURRENCY</strong> - Bulgarian lev (BGN). Euro not adopted yet.</li>
            <li><strong>INDUSTRIES</strong> - Metallurgy, electronics, petrochemicals, tourism, etc.</li>
            <li><strong>EMPLOYMENT</strong> - Averaged 47.42% from 2000 to 2021.</li>
            <li>
              <strong>TOP 3 CITIES</strong>
              <ul>
                <li>Sofia, 1,204,685* inhabitants</li>
                <li>Plovdiv, 334,153* inhabitants</li>
                <li>Varna, 334,870* inhabitants</li>
              </ul>
            </li>
            <li><strong>WEATHER</strong> - Mix of continental & Mediterranean. -1°C to 22°C avg. monthly temps.</li>
          </ul>
          <div class="text-center">
            <img
              src="https://gistcdn.githack.com/juan-bits/75d86fa70faac7bd9de3a9e08741271d/raw/859a3c4f9dea3824d1793a6b479ad057fadfc0cf/bulgaria-flag.svg"
              alt="Flag of Bulgaria"
              class="my-5 CoverageFormat__flag"
              style="width: 150px"
            />
          </div>
        </nav>
  
        <article>
          <p>Bulgaria, established in 681 AD, is one of Europe’s oldest nations and has kept its name throughout history.</p>
          <p>It ranks 3rd in Europe for archaeological sites—after Italy and Greece—making it a top tourist destination.</p>
  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3002379.306725311!2d23.3001916928295!3d42.703486968186645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a8fec1c85bf089%3A0xa01269bf4c10!2sBulgaria!5e0!3m2!1sen!2ses!4v1645524826631!5m2!1sen!2ses"
            width="95%"
            height="450"
            class="CoverageFormat__margins"
            style="border:0"
            allowfullscreen=""
            loading="lazy"
            title="Bulgaria map"
          ></iframe>
  
          <h4 class="mt-4">Tourism in Bulgaria</h4>
          <p>Bulgaria welcomed over 5.8 million tourists in 2019, mainly for vacations and recreation.</p>
  
          <h4 class="mt-4">Main Ports and Airports</h4>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Airport</th>
                <th>City</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>Sofia Airport</td><td>Sofia</td></tr>
              <tr><td>2</td><td>Varna Airport</td><td>Varna</td></tr>
              <tr><td>3</td><td>Burgas Airport</td><td>Burgas</td></tr>
              <tr><td>4</td><td>Plovdiv Airport</td><td>Plovdiv</td></tr>
            </tbody>
          </table>
          <p>Main ports: Balchik, Burgas, Kavarna, Nessebar, Sofia, Varna</p>
  
          <h4 class="mt-5">National Sport in Bulgaria</h4>
          <p>Football is the most popular sport, especially the First Professional Football League.</p>
  
          <h4 class="mt-5">Traditional Bulgarian Cuisine</h4>
          <p>Popular dishes include Banitsa, Tarator, Meshana Skara, and Sarmi.</p>
        </article>
      </section>
  
      <div class="container">
        <h4 class="my-5">Submarine Cables and Connectivity in Bulgaria</h4>
        <a
          href="https://www.submarinecablemap.com/country/bulgaria"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/images/2Zv6hxd.png" alt="Submarine cables in Bulgaria" width="100%" />
        </a>
        <ol class="mt-4">
          <li>Caucasus Cable System</li>
          <li>Kafos Cable</li>
        </ol>
  
        <h4 class="my-4">Access to Landline and Mobile Phones</h4>
        <p>As of 2020, 79% of Bulgarian households had broadband access.</p>
  
        <h4 class="my-4">Internet Access and Speed</h4>
        <p>Bulgaria ranks 20th globally for broadband speed. Avg: 33.5 Mbps download, 22.8 Mbps upload.</p>
        <p>There are over 600 regional ISPs contributing to competitive high-speed access.</p>
  
        <h4 class="my-4">Internet Service Providers</h4>
        <p>10 major ISPs operate in Bulgaria. inte-QT partners with 7 infrastructure-owning providers.</p>
  
        <h4 class="my-4">Our Services and Capabilities</h4>
        <table class="table table-striped mb-5">
          <tbody>
            <tr><td>Dedicated Lines</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Business Broadband</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Wireless Connectivity</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>SLA Support</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>CPE / Router</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>GEMS</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Diverse Gateway Solutions</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>DDoS Protection</td><td><i class="fas fa-check"></i></td></tr>
          </tbody>
        </table>
  
        <p class="CoverageFormat__tag CoverageFormat__margins text-center" align="justify">
          inte-QT delivers <mark>Commercial Offers in 2–3 working days</mark>. Services are typically live within 4–6 weeks.
        </p>
  
        <p class="text-center">
          For more details, <a href="mailto:sales@inte-QT.com?subject=Inquiry from Site">Email Us</a>.
        </p>
  
        <h4>* - References</h4>
        <ul>
          <li><a href="https://climateknowledgeportal.worldbank.org/country/bulgaria/climate-data-historical" target="_blank" rel="noopener noreferrer">Reference 1</a></li>
          <li><a href="https://www.postoffice.co.uk" target="_blank" rel="noopener noreferrer">Reference 2</a></li>
          <li><a href="https://www.infobusiness.bcci.bg/econ3-17-10-14.html" target="_blank" rel="noopener noreferrer">Reference 3</a></li>
          <li><a href="https://www.bbc.co.uk/languages/european_languages/languages/bulgarian.shtml" target="_blank" rel="noopener noreferrer">Reference 4</a></li>
        </ul>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import GetInTouch from '@/components/GetInTouch.vue';
  
  export default {
    name: 'BulgariaPage',
    components: {
      GetInTouch,
    },
    metaInfo() {
      return {
        title: 'Internet in Bulgaria - Coverage, Providers, and Connectivity - inte-QT',
        meta: [
          {
            name: 'description',
            content: 'Explore internet services in Bulgaria, including broadband speed, internet providers, submarine cables, and connectivity solutions by inte-QT.',
          },
          {
            name: 'keywords',
            content: 'Internet in Bulgaria, Broadband, Bulgaria internet providers, submarine cables Bulgaria, mobile phone Bulgaria, internet connectivity, Bulgarian ISPs',
          },
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://www.inte-qt.com/coverage/bulgaria',
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
.CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  